import { LOCAL_STORAGE_PROVIDER_KEY } from '../core/localStorages';

function fitImageBundleBottom() {
  $('.top-image-bundle').outerHeight(function () {
    return $(this).children('div').outerHeight() - 50;
  });
}

function saveLastLoginProvider() {
  const content = document.head.querySelector(
    'meta[name="last_login_provider"]',
  )?.content;
  if (content) {
    localStorage.setItem(LOCAL_STORAGE_PROVIDER_KEY, content);
  }
}

window.addEventListener('load', saveLastLoginProvider);
window.addEventListener('load', fitImageBundleBottom);
window.addEventListener('resize', fitImageBundleBottom);
